import type {CommandSearchCategoryLayout} from './types';

/** Default browse layouts when the query is empty. */
export const DEFAULT_COMMAND_SEARCH_CATEGORY_LAYOUTS: Record<string, CommandSearchCategoryLayout> = {
    recent: {
        variant: 'grid',
        gridSize: {xs: 12, sm: 6, md: 4, lg: 3},
    },
    pages: {
        variant: 'grid',
        gridSize: {xs: 12, sm: 6, md: 6},
    },
    actions: {
        variant: 'grid',
        gridSize: {xs: 12, sm: 6, md: 4},
    },
};

/** Layout applied to every category while the user is searching. */
export const DEFAULT_COMMAND_SEARCH_QUERY_LAYOUT: CommandSearchCategoryLayout = {
    variant: 'row',
};

/**
 * Resolves the layout for a category given browse vs search mode.
 * Navigation (`pages`) and tutorials keep their grid while typing.
 */
export const resolveCommandSearchCategoryLayout = (
    category: string,
    hasQuery: boolean,
    categoryLayouts?: Record<string, CommandSearchCategoryLayout>,
    searchCategoryLayout?: CommandSearchCategoryLayout,
): CommandSearchCategoryLayout => {
    const browseLayout = categoryLayouts?.[category]
        ?? DEFAULT_COMMAND_SEARCH_CATEGORY_LAYOUTS[category]
        ?? {variant: 'row' as const};

    if (hasQuery) {
        if ((category === 'pages' || category === 'tutorials') && browseLayout.variant === 'grid') {
            return browseLayout;
        }
        return searchCategoryLayout ?? DEFAULT_COMMAND_SEARCH_QUERY_LAYOUT;
    }

    return browseLayout;
};
